import React, { useState } from "react";
import "./App.css";
import { I18nProvider, useI18n } from "./i18n/I18nContext";
import CropMarks from "./components/CropMarks";
import StatusBar from "./components/StatusBar";
import SideIndex from "./components/SideIndex";
import Hero from "./sections/Hero";
import Definition from "./sections/Definition";
import WhyNow from "./sections/WhyNow";
import LongView from "./sections/LongView";
import Principles from "./sections/Principles";
import Practices from "./sections/Practices";
import Science from "./sections/Science";
import ToneCheck from "./sections/ToneCheck";
import Bridge from "./sections/Bridge";
import MovementClose from "./sections/MovementClose";
import Footer from "./sections/Footer";
import SourcesDialog from "./components/SourcesDialog";
import ImagePlate from "./components/ImagePlate";

const PLATE_WAVES_LIGHT =
  "https://customer-assets.emergentagent.com/job_ear-future/artifacts/p3sfpfdy_7AF63514-8317-4E88-B3A0-3702B41F80B9.png";
const PLATE_WAVES_RIPPLE =
  "https://customer-assets.emergentagent.com/job_ear-future/artifacts/4ranzdjf_E2142E63-D65B-4DF7-A74E-EB9F38F7F043.png";
const PLATE_WAVES_HORIZON =
  "https://customer-assets.emergentagent.com/job_ear-future/artifacts/yl15b256_1AF0E0DF-8125-444B-BEED-89DB9378D573.png";

function Page() {
  const [sourcesOpen, setSourcesOpen] = useState(false);
  const { t } = useI18n();
  const p = t.plates || {
    light: { tag: "— plate 01", caption: "" },
    ripple: { tag: "— plate 02", caption: "" },
    horizon: { tag: "— plate 03", caption: "" },
  };
  return (
    <>
      <CropMarks />
      <StatusBar />
      <SideIndex />
      <main data-testid="main">
        <Hero />
        <Definition />
        <ImagePlate
          src={PLATE_WAVES_LIGHT}
          alt={p.light.caption}
          tag={p.light.tag}
          caption={p.light.caption}
          testid="plate-light"
          height={560}
        />
        <WhyNow />
        <LongView />
        <ImagePlate
          src={PLATE_WAVES_RIPPLE}
          alt={p.ripple.caption}
          tag={p.ripple.tag}
          caption={p.ripple.caption}
          testid="plate-ripple"
          height={520}
        />
        <Principles />
        <Practices />
        <ImagePlate
          src={PLATE_WAVES_HORIZON}
          alt={p.horizon.caption}
          tag={p.horizon.tag}
          caption={p.horizon.caption}
          testid="plate-horizon"
          height={520}
        />
        <Science onOpenSources={() => setSourcesOpen(true)} />
        <ToneCheck />
        <Bridge />
        <MovementClose />
      </main>
      <Footer onOpenSources={() => setSourcesOpen(true)} />
      <SourcesDialog open={sourcesOpen} onClose={() => setSourcesOpen(false)} />
    </>
  );
}

export default function App() {
  return (
    <I18nProvider>
      <div style={{ background: "var(--bg)", color: "var(--ink)" }}>
        <Page />
      </div>
    </I18nProvider>
  );
}
